const constants = Object.freeze({
  ADMIN: "vos48",
  USER: "vos49",
  SUPER_ADMIN: "vos38",
});

export default constants;
